import API from './API';
import URLSearchParams from 'url-search-params';
import PorderActions from 'actions/PorderActions';
import Search from 'antd/lib/input/Search';

const PorderSource = {
  getRemotePorders: {
    remote(state) {
      const fetchUrl = API.getPorderList;
      const searchParams = new URLSearchParams();
      searchParams.append('status', state.status);
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);

      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: PorderActions.fetchSuccess,
    error: PorderActions.fetchError
  },
  getRemotePorder: {
    remote(state) {
      const fetchUrl = API.getPorderDetail;
      return fetch(fetchUrl.replace(':id', state.porderId)).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: PorderActions.updatePorder,
    error: PorderActions.fetchError
  }
};

export default PorderSource;



// WEBPACK FOOTER //
// ./src/sources/PorderSource.js